const tables = [
  {
    name: "Number",
  },
  {
    name: "Supplier",
  },
  {
    name: "Branch",
  },
  {
    name: "Date",
  },
  {
    name: "Amount",
  },
  {
    name: "Transfer Status",
  },
  // {
  //   name: "Status",
  // },
  {
    name: "Action",
  },
];

export default tables;
